import React from 'react'
import { ProjectFragment } from '@sketch/gql-types'

interface ProjectModalsProps {
  project: ProjectFragment
  onConfirm: () => Promise<unknown>
  onCancelAction: () => void
}

export const RemoveAccessRestrictionsFromProjectModal = (
  props: ProjectModalsProps
) => {
  const { project, onConfirm, onCancelAction } = props

  return {
    title: 'Remove Access Restrictions from Project?',
    children: (
      <p>
        If you remove access restrictions from “<b>{project.name}</b>”,
        everybody in the Workspace will have access to it.
      </p>
    ),
    confirmButton: {
      text: 'Remove Restrictions',
    },
    cancelButton: {
      text: 'Cancel',
    },
    onConfirm,
    onCancelAction,
  }
}

export const RestrictAccessToProjectModal = (props: ProjectModalsProps) => {
  const { project, onConfirm, onCancelAction } = props

  return {
    title: 'Restrict Access to Project?',
    children: (
      <p>
        If you restrict access to “<b>{project.name}</b>”, other Workspace
        Members won&lsquo;t have access — unless you add them.
      </p>
    ),
    confirmButton: {
      text: 'Restrict Access',
    },
    cancelButton: {
      text: 'Cancel',
    },
    onConfirm,
    onCancelAction,
  }
}
